import React from 'react';

export default function LeaderboardTable({ data, sports }) {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Nimi</th>
          {sports.map(sport => (
            <th key={sport.name} style={{ borderBottom: '1px solid #ccc', textAlign: 'center' }}>
              {sport.name}
            </th>
          ))}
          <th style={{ borderBottom: '1px solid #ccc', textAlign: 'center' }}>Yhteensä</th>
        </tr>
      </thead>
      <tbody>
        {data
          .sort((a, b) => b.totalPoints - a.totalPoints)
          .map(p => (
            <tr key={p.id}>
              <td style={{ padding: '4px 8px' }}>{p.name}</td>
              {sports.map(sport => (
                <td key={sport.name} style={{ padding: '4px 8px', textAlign: 'center' }}>
                  {p.points[sport.name] ?? 0}
                </td>
              ))}
              <td style={{ padding: '4px 8px', textAlign: 'center', fontWeight: 'bold' }}>
                {p.totalPoints}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

